import React, { lazy } from 'react'
import { Switch } from 'react-router-dom'
import retry from '../../retry'
import PrivateRoute from '../../components/PrivateRoute'

const  SupplementaryHoursAsStudentTicket = lazy( () =>
  retry( () => import( './ticket/SupplementaryHoursAsStudentTicket' ) )
)

const  SupplementaryHoursAsAcadDeptTicket = lazy( () =>
  retry( () => import( './ticket/SupplementaryHoursAsAcadDeptTicket' ) )
)

const SupplementaryHoursPage = lazy( () =>
  retry( () => import('./ticket/SupplementaryHoursTicketPage') )
)

const SupplementaryHoursRedirectPage = lazy(() =>
    retry( () => import('./ticket/SupplementaryHoursTicketRedirectPage' ) )
)

export default () => (
  <Switch>
    <PrivateRoute
      exact
      path="/protocolos/horas_complementares/new/aluno"
      permission="tickets.add_ticket"
      component={SupplementaryHoursAsStudentTicket}
    />
     <PrivateRoute
      exact
      path="/protocolos/horas_complementares/new/acad"
      permission="tickets.add_ticket"
      component={SupplementaryHoursAsAcadDeptTicket}
    />
     <PrivateRoute
      exact
      path="/protocolos/horas_complementares/new"
      component={SupplementaryHoursRedirectPage}
    />
     <PrivateRoute
      exact
      path="/protocolos/horas_complementares/:id"
      component={SupplementaryHoursPage}
    />
  </Switch>
)
